import React from "react";
import "../../css/SecondaryButton.css";

const SecondaryButton = ({ children, onClick, variant = "filled", ...props }) => {
  return (
    <button
      className={`secondary-btn ${variant === "outlined" ? "secondary-btn--outlined" : "secondary-btn--filled"}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
